<template>
  <div class="ms-form ms-form--narrow">
    <q-form @submit="this.onSubmit">
      <CustomLoader v-if="this.loading" />
      <p v-else-if="!this.volumes.length" class="ms-empty">Объёмы банок для материала не заданы</p>
      <div v-else class="ms-form-grid ms-form-grid--single">
        <CustomInput
          v-for="v in this.volumes"
          :key="v.material_paint_volume_id"
          :label="`${v.volume_name} · остаток ${v.avail_cnt ?? 0}`"
          type="number"
          :min="0"
          :integer="true"
          :required="true"
          :value="v.cnt"
          @change_input="(value) => (v.cnt = value)"
        />
      </div>
      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomLoader from "@/components/common/CustomLoader";
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { getItemPaint } from "@/views/ProviderRequests/services";

export default {
  name: "provider-requests-item-paint",
  components: { CustomLoader, CustomInput, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: true,
      btnLoading: false,
      volumes: [],
    };
  },
  async mounted() {
    const rows = await getItemPaint(this.data?.provider_request_item_id);
    this.volumes = (rows || []).map((r) => ({ ...r, cnt: r.cnt ?? 0 }));
    this.loading = false;
  },
  methods: {
    async onSubmit() {
      this.btnLoading = true;
      await this.data?.onSubmit({
        provider_request_item_id: this.data?.provider_request_item_id,
        volumes: this.volumes.map((v) => ({ material_paint_volume_id: v.material_paint_volume_id, cnt: v.cnt })),
      });
      this.btnLoading = false;
    },
  },
};
</script>
